import { Tooltip, mergeClasses } from "@fluentui/react-components";
import { CheckmarkCircleRegular, SparkleRegular } from "@fluentui/react-icons";
import { useAiDraftedItemNameStyles } from "./AiDraftedItemName.styles";
import { IAiDraftedItemNameProps } from "./AiDraftedItemName.types";

const AI_DRAFTED_LABEL = "AI-drafted";
const REVIEWED_LABEL = "Reviewed";

/**
 * Item name with a marker in front of it: the amber sparkle while the item is
 * AI-drafted and unreviewed, or the green check once the team has reviewed it.
 * Items the team added themselves show the plain name.
 */
export const AiDraftedItemName = ({
  name,
  isAiDrafted,
  isReviewed,
  shouldReserveMarkerSpace,
}: IAiDraftedItemNameProps): JSX.Element => {
  const styles = useAiDraftedItemNameStyles();

  const renderMarker = (): JSX.Element | false => {
    if (isAiDrafted) {
      return (
        <Tooltip content={AI_DRAFTED_LABEL} relationship="label">
          <span
            className={mergeClasses(styles.marker, styles.draftedMarker)}
            role="img"
            aria-label={AI_DRAFTED_LABEL}
          >
            <SparkleRegular aria-hidden="true" />
          </span>
        </Tooltip>
      );
    }
    if (isReviewed) {
      return (
        <Tooltip content={REVIEWED_LABEL} relationship="label">
          <span
            className={mergeClasses(styles.marker, styles.reviewedMarker)}
            role="img"
            aria-label={REVIEWED_LABEL}
          >
            <CheckmarkCircleRegular aria-hidden="true" />
          </span>
        </Tooltip>
      );
    }
    return (
      shouldReserveMarkerSpace && (
        <span className={styles.marker} aria-hidden="true" />
      )
    );
  };

  return (
    <span className={styles.root}>
      {renderMarker()}
      {name}
    </span>
  );
};
